import { Platform } from 'react-native';

export const getMobileOS = async (): Promise<string> => {
  return Platform.OS.toLowerCase();
};
